import { z } from "zod";

const schema = z.object({
  name: z.string().min(1, "Name is required"),
  titleAndEmployer: z.string().optional(),
  location: z.string().optional(),
  yearsOfExperience: z.coerce.number().int().min(0).optional(),
  yearsOfHealthcareExperience: z.coerce.number().int().min(0).optional(),
  profilePicture: z.instanceof(File).optional(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as candidateNameLocationTitleFormSchema,
  type Schema as CandidateNameLocationTitleFormSchema,
};
